import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import to from 'await-to-js';
import { useSetState } from 'react-use';


import AssessmentMultiStep from 'organisms/AssessmentMultiStep';
import Button from 'molecules/Button';
import Checkbox from 'molecules/Checkbox';
import Form, { WrappedForm } from 'organisms/Form';
import HTML from 'molecules/HTML';
import Image from 'molecules/Image';
import Input from 'molecules/Input';
import MaskedInput from 'molecules/MaskedInput';
import Modal from 'molecules/Modal';
import Radio from 'molecules/Radio';
import Select from 'molecules/Select';
import { buildSelectOptions } from 'lib/helpers';


import tempImg from '~static/images/holding-drone.jpg';

import './PopupMultiStep.scss';


/**
 * Popup.
 */
const propTypes = {

}
const PopupMultiStep = React.memo( p => {

  const [ s, setState ] = useSetState( {
    isVisible: p.visible,
  } );
  s.setState = setState;

  const handleClose = () => {

    setState( { isVisible: false } );

    if( typeof window !== 'undefined' ) {
      console.log( window.parent );
    }


    if(
      typeof window !== 'undefined' &&
      !! window.parent && !! window.parent.closeIFrame
    ){

      setTimeout( () => {

        window.parent.closeIFrame();

      }, 500 );

    }
  }
  /* ------ = Output. = --------------------------------------------------------------------- */
  const className = classnames(
    'PopupMulti',
    p.className
  );

  return(

    <Modal
    className={ className }
    visible={ s.isVisible }
    footer={ null }
    onCancel={ handleClose }
    >

      <AssessmentMultiStep inPopup={ true } />

    </Modal>

  )

} );
PopupMultiStep.propTypes = propTypes;

export default PopupMultiStep;
